import { AnyAction, IPartialReducer } from "../../../../core/core-redux/reduxTypes";
import { Wfs3dLayersState } from "../../wfs3dLayers.reducer";

const hideLayersNotInSelectedLayerGroup = (layers: any[], selectedLayerGroup: any) => {
    layers.filter((layer) => layer.group !== selectedLayerGroup).forEach((layer) => (layer.visible = false));
};

export const wfs3dLayerVisibilityPartialReducer: IPartialReducer<Wfs3dLayersState> = (
    state: Wfs3dLayersState,
    action: AnyAction
) => {
    const selectedLayerGroup = action.layerGroup;
    const layers = state.layers ? [...state.layers] : [];

    hideLayersNotInSelectedLayerGroup(layers, selectedLayerGroup);

    const layersInSelectedGroup = layers.filter((layer) => layer.group === selectedLayerGroup);
    for (let i = 0; i < layersInSelectedGroup.length; i++) {
        layersInSelectedGroup[i].visible = action.visibleLayers.includes(layersInSelectedGroup[i].name);
    }

    return {
        layers: layers,
        visibleLayers: action.visibleLayers,
        visibleGroup: selectedLayerGroup,
        //  loading: true, //map.scene.imageryLayers._layers
        //https://community.cesium.com/t/how-to-make-a-loading-screen-that-is-removed-when-base-layer-is-loaded/4097/2
    };
};
